import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Option } from '@com-delta-omnichannel/mach';
import { DropdownItem } from '@com-delta-omnichannel/mach-core-js';
import { BookWidgetFieldInfoModal } from '../../../../models/book-widget-aem.interfaces';
import { LimitedTooltipOptions } from '../info-tooltip-mach-core/info-tooltip-mach-core.component';
import { SelectMachCoreComponent } from '../select-mach-core/select-mach-core.component';

@Component({
  selector: 'idp-best-fare-options-mach-core',
  templateUrl: './best-fare-options-mach-core.component.html',
  standalone: true,
  imports: [SelectMachCoreComponent]
})
export class BestFareOptionsMachCoreComponent {
  @Input() dropdownOptions: Option[] = [];
  @Input() disabled = false;
  @Input() title = '';
  @Input() infoModalContent: BookWidgetFieldInfoModal = {
    description: '',
    title: ''
  };

  @Input() infoTooltipOptions!: LimitedTooltipOptions;

  @Output() bestFareOptionsChange = new EventEmitter<DropdownItem>();
}
